export const SIDES = {
  RIGHT: 'right',
  LEFT: 'left'
};
